module.exports = __webpack_public_path__ + "img/ic_nav_profile.32ce1d52.svg";